import React, { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import DynamicSelectInput from "../../../constant/SelectInput";
import { toast } from "react-toastify";

const PSDForm = ({ handleSubmit, isLoading }) => {
  const [manuals, setManuals] = useState({
    manual_number: "",
    department_id: "",
    title: "",
    unit_id: "",
    description: "",
    file_type:"PDF",
    file: "",
  });

  const [manualsInputError, setManualsInputError] = useState({
    manual_number: false,
  });

  const handleFiles = (file_list) => {
    if (file_list.length) {
      const file = file_list[0];
      const file_ext = file.name.split(".").pop().toUpperCase();
      if (!["PDF", "DWG", "ZIP", "RAR"].includes(file_ext)) {
        toast.error("Please choose a valid PDF file.");
      } else {
        setManuals({ ...manuals, file: file });
      }
    }
  };

  const handleFileInputChange = (e) => {
    const filelist = e.target.files || [];
    handleFiles(filelist);
  };

  const handleSelectChange = (name, value, _) => {
    setManuals({ ...manuals, [name]: value });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setManuals({ ...manuals, [name]: value });

    if (name === "manual_number") {
      setManualsInputError({
        ...manualsInputError,
        manual_number: value.trim() === "",
      });
    }
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    if (manuals.manual_number.trim() === "") {
      setManualsInputError({ ...manualsInputError, manual_number: true });
    } else {
      handleSubmit(e, manuals);
    }
  };

  return (
    <Form onSubmit={handleSubmitForm}>
      <div className="mb-3">
        <label htmlFor="manual_number" className="form-label">
          PSD Number <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className={`form-control ${manualsInputError.manual_number && "is-invalid"
            }`}
          id="manual_number"
          placeholder="Enter PSD Number"
          name="manual_number"
          value={manuals.manual_number}
          onChange={handleChange}
        />
        {manualsInputError.manual_number && (
          <div className="invalid-feedback mt-2">TD No. is required.</div>
        )}
      </div>

      <div className="mb-3">
        <label htmlFor="department_id" className="form-label">
          Department
        </label>
        <DynamicSelectInput
          setParentInputValue={handleSelectChange}
          endpoint_name="search/department"
          name={"department_id"}
          id={"department_id"}
          placeholder={"Select Department"}
          isRequired={true}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="unit" className="form-label">
          Unit
        </label>
        <DynamicSelectInput
          setParentInputValue={handleSelectChange}
          endpoint_name="search/unit"
          name={"unit_id"}
          id={"unit_id"}
          placeholder={"Select Unit"}
          isRequired={true}
        />
      </div>

      <div className="mb-3">
        <label htmlFor="title" className="form-label">
          Title
        </label>
        <input
          type="text"
          className={`form-control ${manualsInputError.title && "is-invalid"
            }`}
          id="title"
          placeholder="Enter Title"
          name="title"
          value={manuals.title}
          onChange={handleChange}
        />
        {manualsInputError.title && (
          <div className="invalid-feedback mt-2">Title is required.</div>
        )}
      </div>

      <div className="mb-3">
        <label htmlFor="description" className="form-label">
          Description
        </label>
        <textarea
          type="text"
          className="form-control"
          id="description"
          placeholder="Enter Description"
          name="description"
          value={manuals.description}
          onChange={handleChange}
        ></textarea>
      </div>
      <div className="form-group mb-3 d-flex">
        <label className="form-label">
          Zip File Type
        </label>
        <div className=" ms-3">
          <div className="form-check custom-checkbox mb-2 form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="file_type"
              id="PDFRadio"
              value="PDF"
              checked={manuals.file_type === "PDF"}
              onChange={handleChange}
            />
            <label
              className="form-check-label"
              htmlFor="PDFRadio"
            >
              PDF
            </label>
          </div>
          <div className="form-check custom-checkbox mb-2 form-check-inline">
            <input
              className="form-check-input"
              type="radio"
              name="file_type"
              id="TIFRadio"
              value="DWG"
              checked={manuals.file_type === "DWG"}
              onChange={handleChange}
            />
            <label
              className="form-check-label"
              htmlFor="TIFRadio"
            >
              DWG
            </label>
          </div>
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="pdfFile" className="form-label">
          Upload File
        </label>
        <input
          type="file"
          className="form-control"
          id="file"
          name="file"
          onChange={handleFileInputChange}
          accept=".zip, .rar"
        />
      </div>
      <div className="d-flex align-items-center justify-content-center mt-2">
        <button
          type="submit"
          disabled={isLoading}
          className="btn btn-primary me-1 w-50">
          {isLoading ? (<span><Spinner size="sm" className="me-2" />Creating...</span>) : "Create"}
        </button>
      </div>
    </Form>
  );
};

export default PSDForm;
